import React from 'react';
import classes from './BookingEngineContainer.scss';

const bookingEngineContainer = (props) => (
    <div className={classes.Container} {...props}>
        {props.children}
    </div>
);

export default bookingEngineContainer;


// WEBPACK FOOTER //
// ./src/components/BookingEngine/BookingEngineContainer/BookingEngineContainer.js